<h3 *ngIf="imagesFiles.length > 1 " class="text-primary mb-4" style="font-weight: 400">
  Imagens da Sinalização
</h3>
<div class="carrousel">
  <div class="carrousel-row">
    <div (click)="moveSlide(-1)" class="box-arrow" *ngIf="imagesFiles.length > 1">
      <i class="fas fa-angle-left fa-lg"></i>
    </div>

    <ng-container *ngFor="let image of imagesFiles; let i=index">
      <div *ngIf="currentIndex == i" class="w-100">
        <img [src]="image?.url" class="image-carrousel" [ngStyle]="{'max-height': maxHeight ? maxHeight+'px' : ''}">
      </div>
    </ng-container>

    <div (click)="moveSlide(1)" class="box-arrow" *ngIf="imagesFiles.length > 1">
      <i class="fas fa-angle-right fa-lg"></i>
    </div>

  </div>

  <div class="carrousel-row my-3" *ngIf="imagesFiles.length > 1">
    <div *ngFor="let index of setIndexItems()" class="carrousel-circle" (click)="currentIndex = index"
      [ngStyle]="{opacity: currentIndex == index ? '1' : '0.3'}">
    </div>
  </div>
</div>
